<template>
    <div>
        <div class="text-center" v-if="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <v-stepper v-model="stepper" alt-labels class="borderless shadowless py-0 mt-4">
                <v-stepper-header class="borderless shadowless">

                    <v-stepper-step :complete="stepper > 1" step="1" class="text-xs-center">Cadre réglementaire de la
                        collecte</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step :complete="stepper > 2" step="2" class="text-xs-center">Communication des
                        données</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 3" step="3" class="text-xs-center">Stockage, lieu et
                        durée</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="4" class="text-xs-center"> Lu et approuvé
                    </v-stepper-step>

                </v-stepper-header>

                <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
                    {{ snackbar_message }}
                </v-snackbar>

                <v-stepper-items class="mt-4">
                    <v-form @submit.prevent="save" ref="form">
                        <v-stepper-content step="1">
                            <v-card flat>
                                <v-card-title>
                                    <h5 class="primary--text">Cadre réglementaire de la collecte</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <div id="dataUrl" style="display: none;"></div>
                                        <div id="dataUrl1" style="display: none;"></div>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <div id="signature-pad" class="signature-pad">
                                                    <div class="signature-pad--body">
                                                        <canvas></canvas>
                                                    </div>
                                                    <div class="signature-pad--footer">
                                                        <div class="signature-pad--actions">
                                                            <div>
                                                                <v-btn data-action="clear">Supprimer</v-btn>
                                                                <v-btn class="button" data-action="undo">Annuler</v-btn>
                                                            </div>
                                                            <div>
                                                                <v-btn data-action="save-png">Enregistrer</v-btn>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <div id="signature-pad1" class="signature-pad">
                                                    <div class="signature-pad--body">
                                                        <canvas></canvas>
                                                    </div>
                                                    <div class="signature-pad--footer">
                                                        <div class="signature-pad--actions">
                                                            <div>
                                                                <v-btn data-action="clear1">Supprimer</v-btn>
                                                                <v-btn class="button" data-action="undo1">Annuler</v-btn>
                                                            </div>
                                                            <div>
                                                                <v-btn data-action="save-png1">Enregistrer</v-btn>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-textarea label="Enoncé de l’activité" value=""
                                            v-model="consent.statement_activity" v-validate="'required'"
                                            :error-messages="errors.collect('énoncé')" data-vv-name="énoncé"
                                            rows="3"></v-textarea>
                                    </v-container>
                                </v-card-text>
                                <v-card-title>
                                    <h5 class="primary--text">Données collectées</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col cols="12" md="4">
                                                <v-text-field label="Nom" v-model="consent.first_name" required
                                                    v-validate="'required'" :error-messages="errors.collect('nom')"
                                                    data-vv-name="nom"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="4">
                                                <v-text-field label="Prénom" v-model="consent.last_name" required
                                                    v-validate="'required'" :error-messages="errors.collect('prénom')"
                                                    data-vv-name="prénom"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="4">
                                                <v-text-field label="E-mail" v-model="consent.email" required
                                                    v-validate="'required|email'" :error-messages="errors.collect('email')"
                                                    data-vv-name="email"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-title>
                                    <h5 class="primary--text">Finalités et utilisation</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-textarea label="La finalité de la collecte est : " value=""
                                            v-model="consent.purposes_use" v-validate="'required'"
                                            :error-messages="errors.collect('finalité')" data-vv-name="finalité"
                                            rows="3"></v-textarea>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(1)"
                                        v-if="$can('create actors')">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-card flat>
                                <v-card-title>
                                    <h5 class="primary--text">Communication des données</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <h5 class="primary--text">Vos données sont communiquées à :</h5>
                                        <div v-for="(item, index) in consent.data_communication" :key="index">
                                            <v-row>
                                                <v-col cols="10">
                                                    <v-text-field :label="(index + 1) + ' .'" v-model="item.value" required
                                                        v-validate="'required'"></v-text-field>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-icon right @click="removeCommunication(index)"
                                                        color="red">mdi-trash-can</v-icon>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-icon right @click="addCommunication" color="primary">mdi-plus</v-icon>
                                        <h5 class="primary--text">Moyen de communication des données :</h5>
                                        <v-checkbox v-model="consent.by_manual" label="Par tradition manuelle"
                                            color="primary"></v-checkbox>
                                        <v-checkbox v-model="consent.by_electronic"
                                            label="Grâce à un système électronique d’échange d’informations sécurisé"
                                            color="primary"></v-checkbox>
                                        <v-checkbox v-model="consent.by_other" label="Autres :"
                                            color="primary"></v-checkbox>
                                        <v-textarea v-if="consent.by_other" label="Autres" value=""
                                            v-model="consent.by_other_content" v-validate="'required'"
                                            rows="2"></v-textarea>

                                        <h5 class="primary--text">Finalité de la communication des données</h5>
                                        <v-textarea label="Finalité" value="" v-model="consent.purpose_communication"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('finalité communication')"
                                            data-vv-name="finalité communication" rows="2"></v-textarea>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 1">Précédent</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(2)"
                                        v-if="$can('create actors')">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card class="mb-2">
                                <v-card-title>
                                    <h5 class="primary--text">Stockage, lieu et durées</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <h5 class="primary--text">Vos données sont stockées :</h5>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-checkbox v-model="consent.in_paper"
                                                    label=" Sous la forme de dossier papier" color="primary"></v-checkbox>
                                            </v-col>

                                            <v-col cols="12" md="6">

                                                <v-checkbox v-model="consent.in_electronic"
                                                    label="Sous la forme de dossier électronique"
                                                    color="primary"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-row>
                                                    <v-col cols="1">
                                                        <v-checkbox v-model="in_benin" hide-details
                                                            color="primary"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="11">
                                                        <v-text-field v-model="consent.in_benin"
                                                            label="Au Bénin auprès de :"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <v-row>
                                                    <v-col cols="1">
                                                        <v-checkbox v-model="abroad_to" hide-details
                                                            color="primary"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="11">
                                                        <v-text-field v-model="consent.abroad_to"
                                                            label="À l’étranger auprès de :"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-row>
                                                    <v-col cols="1">
                                                        <v-checkbox v-model="consent.for_duration" hide-details
                                                            color="primary"></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="11">
                                                        <v-text-field v-model="consent.duration"
                                                            label="Pour la durée du traitement de vos données :"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <v-checkbox v-model="consent.for_period"
                                                    label="Pour une durée de 10 ans maximum" color="primary"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <h5 class="primary--text">Après la durée ci-dessus mentionnée, vos données sont :
                                        </h5>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-checkbox v-model="consent.archived" label="Archivées"
                                                    color="primary"></v-checkbox>
                                            </v-col>

                                            <v-col cols="12" md="6">

                                                <v-checkbox v-model="consent.deleted" label="Supprimées"
                                                    color="primary"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 2">Précédent</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(3)">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-card flat>
                                <v-card-title>
                                    <h5 class="primary--text">Lu et approuvé</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-text-field v-model="consent.institution_name" label="Institution"
                                                    v-validate="'required'" :error-messages="errors.collect('institution')"
                                                    data-vv-name="institution"></v-text-field>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <v-text-field v-model="consent.date" label="Date" type="date"
                                                    v-validate="'required'" :error-messages="errors.collect('date')"
                                                    data-vv-name="date"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <h5 class="primary--text">Signature du chef Mission</h5>
                                            </v-col>

                                            <v-col cols="12" md="6">
                                                <h5 class="primary--text">Signature de l'acteur</h5>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 3">Précédent</v-btn>
                                    <v-btn :loading="loading" :disabled="loading" type="submit" color="primary"
                                        rounded>Enregistrer </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-form>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>
</template>
<script>
import ImageInput from '~/components/ImageInput.vue'
import Form from 'vform'
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
// import { Map, tileLayer, marker, icon } from 'leaflet'
import L from 'leaflet'
import Permissions from '~/mixins/Permissions';

export default {
    name: 'actor-create-consent',
    mixins: [Permissions],
    data: () => ({
        loader: false,
        stepper: 0,
        checkbox: false,
        public_actor: false,
        economic_actor: false,
        snackbar: false,
        snackbar_timeout: 5000,
        snackbar_color: "",
        consent: {
            statement_activity: "",
            first_name: "",
            last_name: "",
            email: "",
            purposes_use: "",
            data_communication: [{ value: '' }],
            by_manual: false,
            by_electronic: false,
            by_other: false,
            purpose_communication: "",
            in_paper: false,
            in_electronic: false,
            in_benin: "",
            abroad_to: "",
            for_duration: false,
            duration: "",
            for_period: false,
            archived: false,
            deleted: false,
            institution_name: "",
            date: "",
            institution_sign: "",
            user_sign: ""
        },
        in_benin: false,
        abroad_to: false,
        png: null,
        user_image: null,
        error: "",
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "#ffed4a",
        },

        disabled: false,
        dataUrl: "",
        saving: false,
        saved: false,
        loading: false,
        edit_mode: false,
        actorId: null,
        photo: null,
        snackbar_message: '',
        cancel_message: 'Annuler',
        filterCount: 0,
        errorsDictionnary: {
            stepFields: {
                step1: ['nom', 'prénom', 'énoncé', 'finalité', 'email'],
                step2: ['finalité communication'],
                step4: ['institution', 'date']
            }
        },
        divValue: ""
    }),
    components: {
        ImageInput: ImageInput
    },
    mounted() {
        this.startDivValueObserver();
    },
    created() {
    },
    computed: {

    },
    watch: {
        "consent.by_other": function () {
            this.consent.by_other_content = "";
        },
        "consent.in_benin": function (val) {
            if (val != "") {
                this.in_benin = true;
            } else {
                this.in_benin = false;
            }
        },
        "consent.abroad_to": function (val) {
            if (val != "") {
                this.abroad_to = true;
            } else {
                this.abroad_to = false;
            }
        },
        "consent.duration": function (val) {
            if (val != "") {
                this.consent.for_duration = true;
            } else {
                this.consent.for_duration = false;
            }
        }
    },
    methods: {
        addCommunication() {
            if (this.consent.data_communication[this.consent.data_communication.length - 1].value !== '') {
                this.consent.data_communication.push({ value: '' });
            } else {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Veuillez remplir tous les champs avant l'ajout";
            }
        },
        removeCommunication(index) {
            if (this.consent.data_communication.length > 1) {
                this.consent.data_communication.splice(index, 1);
            }
        },
        async save() {
            if (this.consent.institution_sign == "" || this.consent.user_sign == "") {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Les signatures sont obligatoires";
                return;
            }
            let canStep = await this.stepCompleted(4)
            if (!canStep) {
                return
            }
            // // Save the consent.
            this.loading = true
            let communication = [];

            for (let index = 0; index < this.consent.data_communication.length; index++) {
                const element = this.consent.data_communication[index];
                communication.push(element.value);
            }

            try {
                var bodyFormData = new FormData();
                bodyFormData.append('statement_activity', this.consent.statement_activity);
                bodyFormData.append('institution_sign', this.consent.institution_sign);
                bodyFormData.append('user_sign', this.consent.user_sign);
                bodyFormData.append('abroad_to', this.consent.abroad_to);
                bodyFormData.append('archived', this.consent.archived == true ? 1 : 0);
                bodyFormData.append('by_electronic', this.consent.by_electronic == true ? 1 : 0);
                bodyFormData.append('by_manual', this.consent.by_manual == true ? 1 : 0);
                bodyFormData.append('by_other', this.consent.by_other == true ? 1 : 0);
                bodyFormData.append('data_communication[]', communication);
                bodyFormData.append('date', this.consent.date);
                bodyFormData.append('deleted', this.consent.deleted == true ? 1 : 0);
                bodyFormData.append('duration', this.consent.duration);
                bodyFormData.append('email', this.consent.email);
                bodyFormData.append('first_name', this.consent.first_name);
                bodyFormData.append('for_duration', this.consent.for_duration == true ? 1 : 0);
                bodyFormData.append('for_period', this.consent.for_period == true ? 1 : 0);
                bodyFormData.append('in_benin', this.consent.in_benin);
                bodyFormData.append('in_electronic', this.consent.in_electronic == true ? 1 : 0);
                bodyFormData.append('in_paper', this.consent.in_paper == true ? 1 : 0);
                bodyFormData.append('institution_name', this.consent.institution_name);
                bodyFormData.append('last_name', this.consent.last_name);
                bodyFormData.append('purpose_communication', this.consent.purpose_communication);
                bodyFormData.append('purposes_use', this.consent.purposes_use);
                bodyFormData.append('statement_activity', this.consent.statement_activity);
                for (var value of bodyFormData.values()) {
                    console.log(value);
                }
                const response = await axios.post("/api/receipt-consents", bodyFormData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                // console.log('Réponse du serveur:', response.data);
                this.loading = false
            } catch (error) {
                console.error('Erreur lors de l\'upload:', error);
                this.loading = false
            }

        },


        async nextStep(step) {
            if (step == 2) {
                for (let index = 0; index < this.consent.data_communication.length; index++) {
                    const element = this.consent.data_communication[index];
                    if (element.value == '') {
                        this.snackbar = true;
                        this.snackbar_color = "error";
                        this.snackbar_message = "Veuillez remplir toute les lignes";
                        return;
                    }
                }
                if (!this.consent.by_manual && !this.consent.by_electronic && !this.consent.by_other) {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Merci de choisir un moyen de communication des données";
                    return;
                }
                if (this.consent.by_other && this.consent.by_other_content == "") {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Veuillez saisir un autre moyen de communication des données";
                    return;
                }

                let canStep = await this.stepCompleted(step)
                if (canStep) {
                    this.stepper = parseInt(step) + 1
                }
            } else if (step == 3) {
                if (!this.consent.in_paper && !this.consent.in_electronic) {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Veuillez choisir la forme de stockage";
                    return;
                }
                if (!this.consent.in_benin && !this.consent.abroad_to) {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Merci de choisir où vous stockez.";
                    return;
                }
                if (this.consent.for_duration && this.consent.duration == "") {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Veuillez saisir une durée.";
                    return;
                }
                if (!this.consent.for_duration && !this.consent.for_period) {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Veuillez sélectionner une durée.";
                    return;
                }
                if (!this.consent.deleted && !this.consent.archived) {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Veuillez sélectionner si vos données sont archivées ou supprimées.";
                    return;
                }
                this.stepper = parseInt(step) + 1
            } else {
                let canStep = await this.stepCompleted(step)
                if (canStep) {
                    this.stepper = parseInt(step) + 1
                }
            }

        },
        async stepCompleted(step) {
            let stepField = this.errorsDictionnary.stepFields['step' + step]
            let validations = []
            for (let index = 0; index < stepField.length; index++) {
                const field = stepField[index];

                validations.push(this.$validator.validate(field))
            }
            const results = Promise.all([
                ...validations
            ]);

            const areValid = (await results).every(isValid => isValid);
            return areValid;
        },
        async fetchCurrentActor() {
            if (this.edit_mode) {
                this.loader = true
                this.cancel_message = 'Enrégistrer et quitter'
                const { data } = await axios.get(`/api/actors/${this.actorId}`)
                this.actor = data
                this.actor.contact = this.actor.contact.split(",")
                this.checkActorType(this.actor.type)
                if (this.actor.contact_whatsapp) {
                    this.checkbox = true
                }
                this.loader = false
                this.$nextTick(function () {
                    this.getPosition()
                });
            }
        },
        showError(error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    this.$dialog.message.error('User denied the request for Geolocation.', {
                        position: 'top-center'
                    })
                    break;
                case error.POSITION_UNAVAILABLE:
                    this.$dialog.message.error('Location information is unavailable.', {
                        position: 'top-center'
                    })
                    break;
                case error.TIMEOUT:
                    this.$dialog.message.error('The request to get user location timed out.', {
                        position: 'top-center'
                    })
                    break;
                case error.UNKNOWN_ERROR:
                    this.$dialog.message.error('An unknown error occurred.', {
                        position: 'top-center'
                    })
                    break;
            }
        },

        cancel() {
            if (this.edit_mode) {
                this.save()
            } else {
                this.$router.push({ name: 'actors.list' })
            }
        },

        startDivValueObserver() {
            const divElement = document.getElementById("dataUrl");
            const divElement1 = document.getElementById("dataUrl1");

            this.divValue = divElement.textContent;
            this.divValue1 = divElement1.textContent;

            setInterval(() => {
                if (divElement.textContent !== this.divValue) {
                    this.divValue = divElement.textContent;
                    this.consent.institution_sign = this.divValue
                }
                if (divElement1.textContent !== this.divValue1) {
                    this.divValue1 = divElement1.textContent;
                    this.consent.user_sign = this.divValue1
                }
            }, 1000); // Vérifier toutes les secondes
        },
    },
}
</script>
<style scoped>
.v-stepper--alt-labels .v-stepper__step {
    justify-content: center;
    align-items: center;
    flex-basis: auto;
}

.theme--light.v-subheader {
    font-size: 1.3em;
    color: black;
}

.map-container {
    position: relative;
    height: 400px;
    width: 890px;
}

.map {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

.signature-pad {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    font-size: 10px;
    width: 100%;
    height: 100%;
    max-width: 700px;
    max-height: 460px;
    border: 1px solid #e8e8e8;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27), 0 0 40px rgba(0, 0, 0, 0.08) inset;
    border-radius: 4px;
    padding: 16px;
}

.signature-pad::before,
.signature-pad::after {
    position: absolute;
    z-index: -1;
    content: "";
    width: 40%;
    height: 10px;
    bottom: 10px;
    background: transparent;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.4);
}

.signature-pad::before {
    left: 20px;
    -webkit-transform: skew(-3deg) rotate(-3deg);
    transform: skew(-3deg) rotate(-3deg);
}

.signature-pad::after {
    right: 20px;
    -webkit-transform: skew(3deg) rotate(3deg);
    transform: skew(3deg) rotate(3deg);
}

.signature-pad--body {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border: 1px solid #f4f4f4;
}

.signature-pad--body canvas {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
}

.signature-pad--footer {
    color: #C3C3C3;
    text-align: center;
    font-size: 1.2em;
    margin-top: 8px;
}

.signature-pad--actions {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/create-consent.vue